import TokenUtilty from '../utils/token.util';

const TOKEN_EXPIRY_PLUGIN = {
  AT_WARNING_THRESHOLD: 1 * 60 * 1000, // 1 minute for token expiry warning
  AT_LAST_ACTION_TIME: 3 * 60 * 1000, // 3 minutes before expiry there was an action
};

export default {
  install(Vue) {
    Vue.prototype.$tokenExpiry = {
      vm: null,
      logoutTimeoutId: null,
      warningTimeoutId: null,
      AutoLogoutTime: TOKEN_EXPIRY_PLUGIN.AT_WARNING_THRESHOLD / 1000,

      init(vm, expiryTime) {
        if (!navigator.onLine) return;

        this.vm = vm;

        if (!expiryTime) {
          return this.logoutNow(vm);
        }

        const timeUntilExpiry = expiryTime - Date.now() - 60 * 1000; // Subtract 1 minute for safety
        const timeUntilWarning = timeUntilExpiry - TOKEN_EXPIRY_PLUGIN.AT_WARNING_THRESHOLD;

        // console.log('timeUntilWarning:', timeUntilWarning / 1000 / 60 + ' minutes');
        // const user = JSON.parse(localStorage.getItem('unhcr_sidar')).user;

        if (timeUntilWarning > 0) {
          this.warningTimeoutId = setTimeout(() => {
            const lastActivity = parseInt(localStorage.getItem('sidar-last-activity'), 10);
            const isActive = Date.now() - lastActivity < TOKEN_EXPIRY_PLUGIN.AT_LAST_ACTION_TIME;

            // if (isActive || user?.role === 'Admin') {
            //   if (user.role === 'Admin') {
            //     console.log('Admin user detected, refreshing token immediately.');
            //   }
            //   this.refreshNow(vm);
            // }
            if (isActive) {
              this.refreshNow(vm);
            } else {
              vm.$root.$emit('show-token-popup');

              this.logoutTimeoutId = setTimeout(() => {
                vm.$root.$emit('hide-token-popup');
                console.log('--- AUTO LOGOUT ---');

                this.logoutNow(vm);
              }, TOKEN_EXPIRY_PLUGIN.AT_WARNING_THRESHOLD);
            }
          }, timeUntilWarning);
        } else {
          console.log('Token already expired or about to expire.');

          this.logoutNow(vm);
        }
      },

      async refreshNow(vm) {
        if (Vue.prototype.$tokenExpiry.logoutTimeoutId) {
          clearTimeout(Vue.prototype.$tokenExpiry.logoutTimeoutId);
          Vue.prototype.$tokenExpiry.logoutTimeoutId = null;
        }

        let response = await vm.$axios.post(`/authentication/refresh-token`).catch((error) => {
          console.log('Error refreshing token:', error);

          this.logoutNow(vm);
        });

        if (!response) {
          return;
        }

        vm.$broadcastToken(response.data.result.data.accessToken);
        vm.$root.$emit('hide-token-popup');

        const payload = TokenUtilty.decodeToken(response.data.result.data.accessToken);
        const tokenExpiryTime = new Date(payload.exp).getTime();

        this.init(vm, tokenExpiryTime);
      },

      async logoutNow(vm) {
        vm.$root.$emit('hide-token-popup');

        if (Vue.prototype.$tokenExpiry.logoutTimeoutId) {
          clearTimeout(Vue.prototype.$tokenExpiry.logoutTimeoutId);
          Vue.prototype.$tokenExpiry.logoutTimeoutId = null;
        }

        if (Vue.prototype.$tokenExpiry.warningTimeoutId) {
          clearTimeout(Vue.prototype.$tokenExpiry.warningTimeoutId);
          Vue.prototype.$tokenExpiry.warningTimeoutId = null;
        }

        localStorage.removeItem('sidar-last-activity');
        await vm.$root.logout();

        console.log('User logged out due to inactivity or token expiry.');
      },
    };

    window.addEventListener('storage', (event) => {
      if (event.key === 'accessToken') {
        const tokenExpiryPlugin = Vue.prototype.$tokenExpiry;
        const vm = tokenExpiryPlugin.vm;

        if (tokenExpiryPlugin.logoutTimeoutId) {
          clearTimeout(tokenExpiryPlugin.logoutTimeoutId);
          tokenExpiryPlugin.logoutTimeoutId = null;
        }

        if (Vue.prototype.$tokenExpiry.warningTimeoutId) {
          clearTimeout(Vue.prototype.$tokenExpiry.warningTimeoutId);
          Vue.prototype.$tokenExpiry.warningTimeoutId = null;
        }

        vm.$emit('hide-token-popup');
        vm.$root.$emit('hide-token-popup');

        const newToken = localStorage.getItem('accessToken');

        if (newToken) {
          vm.$emit('hide-token-popup');

          const payload = TokenUtilty.decodeToken(newToken);
          const tokenExpiryTime = new Date(payload.exp).getTime();

          Vue.prototype.$tokenExpiry.init(vm, tokenExpiryTime);
        }
      }
    });
  },
};
